var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArr1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 21,
    viewBox: "0 0 35 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 1H29C31.7614 1 34 3.23858 34 6V20H6C3.23858 20 1 17.7614 1 15V1Z",
    stroke: "#E85446",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2344 10.1199L24.9544 6.05591V7.92791L20.7784 10.5199L24.9544 13.0479V14.9999L18.2344 10.9999V10.1199Z",
    fill: "#E85446"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0469 10.1199L16.7669 6.05591V7.92791L12.5909 10.5199L16.7669 13.0479V14.9999L10.0469 10.9999V10.1199Z",
    fill: "#E85446"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArr1);
export default __webpack_public_path__ + "static/media/arr1.e9490e51e615607eba078fad6fca3254.svg";
export { ForwardRef as ReactComponent };